import axios from "axios";
import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { env } from "../../env/env";
import toast, { Toaster } from "react-hot-toast";
import logoencuesta from "../../img/picture.png";
import { logDOM } from "@testing-library/react";
const API_ENDPOINT = `${ env.API_ENDPOINT }`;



const Gravámenes = () => {

    const [ activar_gravamenes, setactivar_gravamenes ] = useState( false );
    const [ activar_busqueda, setactivar_busqueda ] = useState( false );
    const [ activar_ct, setactivar_ct ] = useState( false );
    const [ activar_bienes, setactivar_bienes ] = useState( false );
    const cambiotipocertificado = async () => {
        if ( web_tipo_fomulario_tic.current.value.includes( "GRAVAMEN" ) ) {
            await setactivar_gravamenes( true );
            await setactivar_busqueda( false );
            await setactivar_ct( false );
            await setactivar_bienes( false );
        }

        if ( web_tipo_fomulario_tic.current.value === "" ) {
            await setactivar_gravamenes( false );
            await setactivar_busqueda( false );
            await setactivar_ct( false );
            await setactivar_bienes( false );
        }
        if ( web_tipo_fomulario_tic.current.value === "CERTIFICADO DE BIENES" ) {
            await setactivar_gravamenes( false );
            await setactivar_busqueda( false );
            await setactivar_ct( false );
            await setactivar_bienes( true );
        }
        if ( web_tipo_fomulario_tic.current.value === "CERTIFICADO DE BUSQUEDAS" ) {
            await setactivar_gravamenes( false );
            await setactivar_busqueda( true );
            await setactivar_ct( false );
            await setactivar_bienes( false );
        }
        if ( web_tipo_fomulario_tic.current.value === "COPIA TEXTUAL" ) {
            await setactivar_gravamenes( false );
            await setactivar_busqueda( false );
            await setactivar_ct( true );
            await setactivar_bienes( false );
        }

    };

    //DATOS PARA FACTURACIÓN
    const web_cedula_fac = useRef();
    const web_nombres_fac = useRef();
    const web_direccion_fac = useRef();
    const web_telefono_fac = useRef();
    const web_correo_fac = useRef();
    const web_tipo_fomulario_tic = useRef();

    //DATOS DEL PROPIETARIO/S (Y CÓNYUGUE) / OTROS
    const web_apellidos_nombres_pro = useRef();
    const web_nomb_conyu_pro = useRef();

    //DATOS DEL TÍTULO DE ADQUISICIÓN
    const web_tipo_contrato_pre = useRef();
    const web_propie_anterior_pre = useRef();
    const [ web_fecha_otorga_pre, setweb_fecha_otorga_pre ] = useState( null );
    const web_notaria_pre = useRef();
    const [ web_fecha_incripcion_pre, setweb_fecha_incripcion_pre ] = useState( null );
    const web_numero_partida_pre = useRef();

    //*DATOS DEL PREDIO
    const web_parroquia_pre = useRef();
    const web_Lote_pre = useRef();
    const web_manzana_pre = useRef();
    const web_sector_pre = useRef();
    //*nuevos
    const web_casa_pre = useRef();
    const web_local_pre = useRef();
    const web_otros_pre = useRef();

    //SI EXISTE UNA DECLARATORIA DE PROPIEDAD HORIZONTAL / FRACCIONAMIENTO / UNIFICACIÓN DE PREDIOS
    const web_notaria_dph = useRef();
    const [ web_escritura_proto_dph, setweb_escritura_proto_dph ] = useState( null );
    const web_bajo_partidas_dph = useRef();
    const web_bien_exclusivo_dph = useRef();
    //nuevo
    const [ web_fecha_proto_otor_dph, setweb_fecha_proto_otor_dph ] = useState( null );
    const web_lote_dph = useRef();
    const web_manzana_dph = useRef();


    // INFORMACIÓN PARA CERTIFICADO DE BÚSQUEDA
    const web_tipo_contrato_bb = useRef();
    const web_parroquia_bb = useRef();
    const web_canton_bb = useRef();
    const web_nombre_propiet_bb = useRef();
    const web_apellidos_vendedor_bb = useRef();
    const [ web_fecha_aproxi_bb, setweb_fecha_aproxi_bb ] = useState( null );
    const web_anio_desde_bb = useRef();
    const web_anio_hasta_bb = useRef();

    // INFORMACIÓN PARA COPIA TEXTUAL - ÍNTEGRA
    const web_tipo_contrato_ct = useRef();
    const web_npartida_ct = useRef();
    const web_anioinscripcion_ct = useRef();

    //INFORMACIÓN PARA CERTIFICADO DE BIENES
    //nuevo
    const web_ncedula_bienes = useRef();
    const web_apellidos_nombres_bienes = useRef();
    const web_indole_tic = useRef();

    //DATOS ADICIONALES
    const datos_adicionales = useRef();

    const transformarfechas = async ( fecha ) => {
        //fecha salida
        var fechaformatobdd = "";
        var fechaFormato = new Date( fecha );
        if ( fecha === null || fecha === "" ) {
            fechaFormato = "";
        } else {
            fechaformatobdd =
                fechaFormato.getDate() +
                "-" +
                ( fechaFormato.getMonth() + 1 ) +
                "-" +
                fechaFormato.getFullYear() + " " + fechaFormato.getHours() + ":" + fechaFormato.getMinutes() + ":00";
        }
        return fechaformatobdd;
    };

    const [ File, setFile ] = useState( null );

    const onFileChange = ( event ) => {
        setFile( event.target.files[ 0 ] );
    };

    const [ tramitegenerado, settramitegenerado ] = useState( null );
    const [ activar_formulario, setactivar_formulario ] = useState( false );
    const onFileUpload = async () => {
        const formData = new FormData();

        //DATOS PARA FACTURACIÓN
        formData.append( "web_cedula_fac", web_cedula_fac.current.value );
        formData.append( "web_nombres_fac", web_nombres_fac.current.value );
        formData.append( "web_direccion_fac", web_direccion_fac.current.value );
        formData.append( "web_telefono_fac", web_telefono_fac.current.value );
        formData.append( "web_correo_fac", web_correo_fac.current.value );
        formData.append( "web_tipo_fomulario_tic", web_tipo_fomulario_tic.current.value );

        //DATOS DEL PROPIETARIO/S (Y CÓNYUGUE) / OTROS
        formData.append( "web_apellidos_nombres_pro", web_apellidos_nombres_pro.current.value );
        formData.append( "web_nomb_conyu_pro", web_nomb_conyu_pro.current.value );

        //DATOS DEL TÍTULO DE ADQUISICIÓN
        formData.append( "web_tipo_contrato_pre", web_tipo_contrato_pre.current.value );
        formData.append( "web_propie_anterior_pre", web_propie_anterior_pre.current.value );
        formData.append( "web_fecha_otorga_pre", await transformarfechas( web_fecha_otorga_pre ) );
        formData.append( "web_notaria_pre", web_notaria_pre.current.value )
        formData.append( "web_fecha_incripcion_pre", await transformarfechas( web_fecha_incripcion_pre ) )
        formData.append( "web_numero_partida_pre", web_numero_partida_pre.current.value );

        //*DATOS DEL PREDIO
        formData.append( "web_parroquia_pre", web_parroquia_pre.current.value );
        formData.append( "web_Lote_pre", web_Lote_pre.current.value );
        formData.append( "web_manzana_pre", web_manzana_pre.current.value );
        formData.append( "web_sector_pre", web_sector_pre.current.value );
        //*nuevos
        formData.append( "web_casa_pre", web_casa_pre.current.value );
        formData.append( "web_local_pre", web_local_pre.current.value );
        formData.append( "web_otros_pre", web_otros_pre.current.value );

        //SI EXISTE UNA DECLARATORIA DE PROPIEDAD HORIZONTAL / FRACCIONAMIENTO / UNIFICACIÓN DE PREDIOS
        formData.append( "web_notaria_dph", web_notaria_dph.current.value );
        formData.append( "web_escritura_proto_dph", await transformarfechas( web_escritura_proto_dph ) );
        formData.append( "web_bajo_partidas_dph", web_bajo_partidas_dph.current.value );
        formData.append( "web_bien_exclusivo_dph", web_bien_exclusivo_dph.current.value );
        //nuevo
        formData.append( "web_fecha_proto_otor_dph", await transformarfechas( web_fecha_proto_otor_dph ) )
        formData.append( "web_lote_dph", web_lote_dph.current.value );
        formData.append( "web_manzana_dph", web_manzana_dph.current.value );


        // INFORMACIÓN PARA CERTIFICADO DE BÚSQUEDA
        formData.append( "web_tipo_contrato_bb", web_tipo_contrato_bb.current.value );
        formData.append( "web_parroquia_bb", web_parroquia_bb.current.value );
        formData.append( "web_canton_bb", web_canton_bb.current.value );
        formData.append( "web_nombre_propiet_bb", web_nombre_propiet_bb.current.value );
        formData.append( "web_apellidos_vendedor_bb", web_apellidos_vendedor_bb.current.value );
        formData.append( "web_fecha_aproxi_bb", await transformarfechas( web_fecha_aproxi_bb ) );
        formData.append( "web_anio_desde_bb", web_anio_desde_bb.current.value );
        formData.append( "web_anio_hasta_bb", web_anio_hasta_bb.current.value );

        // INFORMACIÓN PARA COPIA TEXTUAL - ÍNTEGRA
        //nuevos
        formData.append( "web_tipo_contrato_ct", web_tipo_contrato_ct.current.value );
        formData.append( "web_npartida_ct", web_npartida_ct.current.value );
        formData.append( "web_anioinscripcion_ct", web_anioinscripcion_ct.current.value );

        //INFORMACIÓN PARA CERTIFICADO DE BIENES
        //nuevo
        formData.append( "web_ncedula_bienes", web_ncedula_bienes.current.value );
        formData.append( "web_apellidos_nombres_bienes", web_apellidos_nombres_bienes.current.value );
        formData.append( "web_file_bienes", File );


        // TODOS 
        formData.append( "web_indole_tic", web_indole_tic.current.value );

        //DATOS ADICIONALES
        formData.append( "web_datos_adicionales", datos_adicionales.current.value );

        var checkeo = 0;
        if ( web_cedula_fac.current.value === "" ) {
            checkeo = 1;
            toast.error( "La cédula de facturación no puede estar vacio" );
        }
        if ( web_nombres_fac.current.value === "" ) {
            checkeo = 1;
            toast.error( "Los nombres de facturación estar vacio" );
        }
        if ( web_direccion_fac.current.value === "" ) {
            checkeo = 1;
            toast.error( "La dirección de facturación no puede estar vacio" );
        }
        if ( web_telefono_fac.current.value === "" ) {
            checkeo = 1;
            toast.error( "El teléfono de facturación no puede estar vacio" );
        }
        if ( web_correo_fac.current.value === "" ) {
            checkeo = 1;
            toast.error( "El correo de facturación no puede estar vacio" );
        }
        if ( web_tipo_fomulario_tic.current.value === "" ) {
            checkeo = 1;
            toast.error( "El tipo de certificado no puede estar vacio" );
        }


        if ( web_tipo_fomulario_tic.current.value.includes( "GRAVAMEN" ) ) {
            if ( web_apellidos_nombres_pro.current.value === "" ) {
                checkeo = 1;
                toast.error( "Nombre propietario del predio no puede estar vacio" );
            }
            if ( web_fecha_otorga_pre === "" || web_fecha_otorga_pre === null ) {
                checkeo = 1;
                toast.error( "Fecha de orogamiento del predio no puede estar vacio" );
            }
            if ( web_fecha_incripcion_pre === "" || web_fecha_incripcion_pre === null ) {
                checkeo = 1;
                toast.error( "Fecha de Inscripción del predio no puede estar vacio" );
            }
            if ( web_propie_anterior_pre.current.value === "" ) {
                checkeo = 1;
                toast.error( "Propietario Anterior del predio no puede estar vacio" );
            }
            if ( web_notaria_pre.current.value === "" ) {
                checkeo = 1;
                toast.error( "Notaria del predio no puede estar vacío" );
            }
            if ( web_numero_partida_pre.current.value === "" ) {
                checkeo = 1;
                toast.error( "Ingrese el numero de partida si no tiene puede preguntar en balcón de servicios" );
            }
        }
        if ( web_tipo_fomulario_tic.current.value === "CERTIFICADO DE BIENES" ) {
            if ( web_ncedula_bienes.current.value === "" ) {
                checkeo = 1;
                toast.error( "La cédula no puede estar vacío" );
            }
            if ( web_apellidos_nombres_bienes.current.value === "" ) {
                checkeo = 1;
                toast.error( "Apellidos y nombres no puede estar vacío" );
            }
            if ( File === null ) {
                checkeo = 1;
                toast.error( "El archivo de CERTIFICADO DE PROPIEDADES CATASTRADAS DEL MUNICIPIO es obligatorio" );
            }
        }
        if ( web_tipo_fomulario_tic.current.value === "CERTIFICADO DE BUSQUEDAS" ) {
            if ( web_tipo_contrato_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Tipo de acto / contrato no puede estar vacío" );
            }
            if ( web_parroquia_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Parroquia no puede estar vacío" );
            }
            if ( web_canton_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Cantón no puede estar vacío" );
            }
            if ( web_nombre_propiet_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Nombres y apellidos del propietario(s) no puede estar vacío" );
            }
            if ( web_apellidos_vendedor_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Nombres y apellidos del otorgante no puede estar vacío" );
            }
            if ( web_fecha_aproxi_bb === "" || web_fecha_aproxi_bb === null ) {
                checkeo = 1;
                toast.error( "Fecha aproximada de realización del contrato no puede estar vacío" );
            }
            if ( web_anio_desde_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Buscar desde(año) no puede estar vacío" );
            }
            if ( web_anio_hasta_bb.current.value === "" ) {
                checkeo = 1;
                toast.error( "Buscar hasta(año) no puede estar vacío" );
            }

        }
        if ( web_tipo_fomulario_tic.current.value === "COPIA TEXTUAL" ) {
            if ( web_tipo_contrato_ct.current.value === "" ) {
                checkeo = 1;
                toast.error( "Tipo de acto / contrato no puede estar vacío" );
            }
            if ( web_npartida_ct.current.value === "" ) {
                checkeo = 1;
                toast.error( "Nro. Partida no puede estar vacío" );
            }
            if ( web_anioinscripcion_ct.current.value === "" ) {
                checkeo = 1;
                toast.error( "Año de Inscripción no puede estar vacío" );
            }
        }
        if ( web_indole_tic.current.value === "" ) {
            checkeo = 1;
            toast.error( "Elija el objetivo del formulario (se encuentra en la parte inferior)" );
        }




        if ( checkeo === 0 ) {
            const toastId = toast.loading( 'Generando formulario espere por favor...' );
            axios.post( `${ env.API_ENDPOINT }/nuevoformulario`, formData ).then(
                async ( response ) => {
                    await settramitegenerado( response.data );
                    await setactivar_formulario( true );
                    await setactivar_gravamenes( false );
                    await setactivar_busqueda( false );
                    await setactivar_ct( false );
                    await setactivar_bienes( false );
                    await setisOpenObs( false );
                    toast.dismiss( toastId );

                },
                ( error ) => {
                    console.log( error );
                    toast.error( "Error del sistema!" );
                }
            );


        }

    };

    const [ isOpenObs, setisOpenObs ] = useState( false );
    const [ isOpenSurvey, setisOpenSurvey ] = useState( false );


    const getdatosfact = async () => {


        await axios
            .post( API_ENDPOINT + '/getdatosfact', {
                cedula: web_cedula_fac.current.value,
            } )
            .then( function ( response ) {
                // handle success  
                if ( response.data.length == 0 ) {
                    toast.error( 'No se han encontrado datos!' );
                }
                else {

                    if ( response.data === "0" || response.data === 0 ) {
                        toast.error( 'La cédula ingresada es incorrecta!' );
                        web_nombres_fac.current.value = "";
                        web_direccion_fac.current.value = "";
                        web_telefono_fac.current.value = "";
                        web_correo_fac.current.value = "";

                    } else {
                        web_nombres_fac.current.value = response.data[ 0 ].cli_nombre_largo;
                        web_direccion_fac.current.value = response.data[ 0 ].cli_direccion;
                        web_telefono_fac.current.value = response.data[ 0 ].cli_telefono;
                        web_correo_fac.current.value = response.data[ 0 ].cli_email;
                        toast.success( 'Datos encontrados con éxito!' );
                    }


                }

            } )
            .catch( function ( error ) {
                // handle error
                //  console.log(error);
                toast.error( " Ha ocurrido un error!" );
            } );
    };


    const [ habilitarcerrar, sethabilitarcerrar ] = useState( false )

    const guardarpregunta = async ( npregunta, respuesta ) => {
        await axios
            .post( API_ENDPOINT + '/encuesta', {
                cedula: sessionStorage.getItem( "usuario" ).trim(),
                npregunta: npregunta,
                respuesta: respuesta
            } )
            .then( function ( response ) {
                // handle success  
                toast.success( "Respuesta guardada con éxito!" );
                if ( npregunta === 5 ) {
                    sethabilitarcerrar( true );
                }
            } )
            .catch( function ( error ) {
                // handle error
                //  console.log(error);
                toast.error( " Ha ocurrido un error!" );
            } );
    };
    const finaliza_encuesta = async () => {
        await setisOpenObs( true );
        await setisOpenSurvey( false );
    };

    return (
        <>
            <Toaster />
            <section className="content">
                <div class="alert alert-success" role="alert" style={ { display: activar_formulario === false ? "none" : "flow-root" } }>
                    Formulario Generado con éxito, Tu número de trámite es el siguiente:   <strong>{ tramitegenerado }</strong> Los datos se han enviado al correo electrónico registrado
                </div>
                <div className="row">
                    <div className="col-md-12">
                        {/* Profile Image */ }

                        {/* card */ }
                        {/* Dropdown Card Example */ }
                        <div className="card border-left-danger shadow  py-2" style={ { display: activar_formulario === true ? "none" : "flow-root" } }>
                            {/* Card Header - Dropdown */ }
                            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-danger">DATOS PARA FACTURACIÓN:</h6>
                            </div>
                            {/* Card Body */ }
                            <div className="card-body">

                                <div className="user">
                                    <div className="form-group row">
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-danger">Cédula:</label>
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_cedula_fac } />
                                        </div>
                                        <div className="col-sm-1 mb-3 mb-sm-0">
                                            <label style={ { color: 'white' } }>Buscar:</label>
                                            <button className="btn btn-danger" style={ { width: '100%' } } onClick={ getdatosfact }><i class="fas fa-search"></i></button>
                                        </div>
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <label className="text-danger">Nombres o Razón Social:</label>
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_nombres_fac } />
                                        </div>
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <label className="text-danger">Dirección:</label>
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_direccion_fac } />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <label className="text-danger">Teléfono:</label>
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_telefono_fac } />
                                        </div>
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <label className="text-danger">Correo:</label>
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_correo_fac } />
                                        </div>
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <label className="text-danger">Tipo de Certificado:</label>
                                            <select className="form-control form-control-user" onChange={ cambiotipocertificado } ref={ web_tipo_fomulario_tic }>
                                                <option value="">Seleccione:</option>
                                                <option value="CERTIFICADO DE GRAVAMEN">CERTIFICADO DE GRAVAMEN</option>
                                                <option value="CERTIFICADO DE GRAVAMEN CON DESCRIPCIÓN DE VENTAS">CERTIFICADO DE GRAVAMEN CON DESCRIPCIÓN DE VENTAS</option>
                                                <option value="CERTIFICADO DE GRAVAMEN CON HISTORIAL DE DOMINIO">CERTIFICADO DE GRAVAMEN CON HISTORIAL DE DOMINIO</option>
                                                <option value="CERTIFICADO DE GRAVAMEN CON DESCRIPCIÓN DE VENTAS E HISTORIAL DE DOMINIO">CERTIFICADO DE GRAVAMEN CON DESCRIPCIÓN DE VENTAS E HISTORIAL DE DOMINIO</option>
                                                <option value="CERTIFICADO DE BIENES">CERTIFICADO DE BIENES</option>
                                                <option value="CERTIFICADO DE BUSQUEDAS">CERTIFICADO DE BUSQUEDAS</option>
                                                <option value="COPIA TEXTUAL">COPIA TEXTUAL</option>

                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div id="gravamen" style={ { display: activar_gravamenes === true ? "flow-root" : "none" } }>
                            <div className="card border-left-primary shadow  py-2">
                                {/* Card Header - Dropdown */ }
                                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">DATOS DEL PROPIETARIO/S (Y CÓNYUGUE) / OTROS:</h6>
                                </div>
                                {/* Card Body */ }
                                <div className="card-body">
                                    <div className="user">
                                        <div className="form-group row">
                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <label className="text-primary">Nombres y apellidos:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_apellidos_nombres_pro } />
                                            </div>
                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <label className="text-primary">Nombres del cónyugue / otros:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_nomb_conyu_pro } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><br />
                            <div className="card border-left-primary shadow  py-2">
                                {/* Card Header - Dropdown */ }
                                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">DATOS DEL TÍTULO DE ADQUISICIÓN:</h6>
                                </div>
                                {/* Card Body */ }
                                <div className="card-body">
                                    <div className="user">
                                        <div className="form-group row">
                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <label className="text-primary">Tipo de acto / contrato:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_tipo_contrato_pre } />
                                            </div>
                                            <div className="col-sm-6 mb-3 mb-sm-0">
                                                <label className="text-primary">Propietario(s) anterior(es):</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_propie_anterior_pre } />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Fecha de otorgamiento:</label><br />
                                                <DatePicker
                                                    className="form-control form-control-user"
                                                    selected={ web_fecha_otorga_pre }
                                                    onChange={ ( date ) => setweb_fecha_otorga_pre( date ) }
                                                    timeInputLabel="Hora:"
                                                    dateFormat="dd/MM/yyyy"
                                                /* showTimeInput */
                                                />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Notaría:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_notaria_pre } />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Fecha de inscripción:</label><br />
                                                <DatePicker
                                                    className="form-control form-control-user"
                                                    selected={ web_fecha_incripcion_pre }
                                                    onChange={ ( date ) => setweb_fecha_incripcion_pre( date ) }
                                                    timeInputLabel="Hora:"
                                                    dateFormat="dd/MM/yyyy"

                                                />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">N° de partida:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_numero_partida_pre } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div><br />
                            <div className="card border-left-primary shadow  py-2">
                                {/* Card Header - Dropdown */ }
                                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">DATOS DEL PREDIO:</h6>
                                </div>
                                {/* Card Body */ }
                                <div className="card-body">
                                    <div className="user">
                                        <div className="form-group row">
                                            <div className="col-sm-2 mb-3 mb-sm-0">
                                                <label className="text-primary">Parroquia:</label>
                                                <select
                                                    class="form-control"
                                                    ref={ web_parroquia_pre }
                                                >
                                                    <option value="">Seleccione:</option>
                                                    <option value="AMBUQUI">AMBUQUI</option>
                                                    <option value="ANGOCHAGUA">ANGOCHAGUA</option>
                                                    <option value="ATUNTAQUI">ATUNTAQUI</option>
                                                    <option value="CARANQUI">CARANQUI</option>
                                                    <option value="EL SAGRARIO">EL SAGRARIO</option>
                                                    <option value="GENERAL">GENERAL</option>
                                                    <option value="GUAYAQUIL DE ALPACHACA">
                                                        GUAYAQUIL DE ALPACHACA
                                                    </option>
                                                    <option value="LA CAROLINA">LA CAROLINA</option>
                                                    <option value="LA DOLOROSA DE PRIORATO">
                                                        LA DOLOROSA DE PRIORATO
                                                    </option>
                                                    <option value="LA ESPERANZA">LA ESPERANZA</option>
                                                    <option value="LITA">LITA </option>
                                                    <option value="PIMAMPIRO">PIMAMPIRO</option>
                                                    <option value="SALINAS">SALINAS</option>
                                                    <option value="SAN ANTONIO">SAN ANTONIO</option>
                                                    <option value="SAN FRANCISCO">SAN FRANCISCO</option>
                                                    <option value="URCUQUI">URCUQUI</option>
                                                </select>                                            </div>
                                            <div className="col-sm-2 mb-3 mb-sm-0">
                                                <label className="text-primary">Lote Nro:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_Lote_pre } />
                                            </div>
                                            <div className="col-sm-2 mb-3 mb-sm-0">
                                                <label className="text-primary">Manzana:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_manzana_pre } />
                                            </div>
                                            <div className="col-sm-2 mb-3 mb-sm-0">
                                                <label className="text-primary">Casa:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_casa_pre } />
                                            </div>
                                            <div className="col-sm-1 mb-3 mb-sm-0">
                                                <label className="text-primary">Local:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_local_pre } />
                                            </div>
                                            <div className="col-sm-2 mb-3 mb-sm-0">
                                                <label className="text-primary">Otros:</label>
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_otros_pre } />
                                            </div>
                                            <div className="col-sm-1 mb-3 mb-sm-0">
                                                <label className="text-primary">Sector:</label>
                                                <select
                                                    class="form-control"
                                                    ref={ web_sector_pre }
                                                >
                                                    <option value="" selected>Seleccione:</option>
                                                    <option value="Urbano">Urbano</option>
                                                    <option value="Rural">Rural</option>
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div><br />
                            <div className="card border-left-primary shadow  py-2">
                                {/* Card Header - Dropdown */ }
                                <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 className="m-0 font-weight-bold text-primary">SI EXISTE UNA DECLARATORIA DE PROPIEDAD HORIZONTAL / FRACCIONAMIENTO / UNIFICACIÓN DE PREDIOS:</h6>
                                </div>
                                {/* Card Body */ }
                                <div className="card-body">
                                    <div className="user">
                                        <div className="form-group row">
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Fecha de protocolización y/o otorgamiento:</label><br />
                                                <DatePicker
                                                    className="form-control form-control-user"
                                                    selected={ web_fecha_proto_otor_dph }
                                                    onChange={ ( date ) => setweb_fecha_proto_otor_dph( date ) }
                                                    timeInputLabel="Hora:"
                                                    dateFormat="dd/MM/yyyy"
                                                />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Notaría:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_notaria_dph } />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Lote Nro.:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_lote_dph } />
                                            </div>

                                        </div>
                                        <div className="form-group row">
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Fecha de inscripción:</label><br />
                                                <DatePicker
                                                    className="form-control form-control-user"
                                                    selected={ web_escritura_proto_dph }
                                                    onChange={ ( date ) => setweb_escritura_proto_dph( date ) }
                                                    timeInputLabel="Hora:"
                                                    dateFormat="dd/MM/yyyy"
                                                />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Bajo las partidas Nros.:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_bajo_partidas_dph } />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Bien Exclusivo:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_bien_exclusivo_dph } />
                                            </div>
                                            <div className="col-sm-3 mb-3 mb-sm-0">
                                                <label className="text-primary">Manzana:</label><br />
                                                <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_manzana_dph } />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="card border-left-primary shadow  py-2" style={ { display: activar_busqueda === true ? "flow-root" : "none" } }>
                            {/* Card Header - Dropdown */ }
                            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-primary">INFORMACIÓN PARA CERTIFICADO DE BÚSQUEDA (Búsqueda no mayor a 10 años)</h6>
                            </div>
                            {/* Card Body */ }
                            <div className="card-body">
                                <div className="user">
                                    <div className="form-group row">
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary" >Tipo de acto / contrato:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_tipo_contrato_bb } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Parroquia:</label><br />
                                            <select
                                                class="form-control"
                                                ref={ web_parroquia_bb }
                                            >
                                                <option value="">Seleccione:</option>
                                                <option value="AMBUQUI">AMBUQUI</option>
                                                <option value="ANGOCHAGUA">ANGOCHAGUA</option>
                                                <option value="ATUNTAQUI">ATUNTAQUI</option>
                                                <option value="CARANQUI">CARANQUI</option>
                                                <option value="EL SAGRARIO">EL SAGRARIO</option>
                                                <option value="GENERAL">GENERAL</option>
                                                <option value="GUAYAQUIL DE ALPACHACA">
                                                    GUAYAQUIL DE ALPACHACA
                                                </option>
                                                <option value="LA CAROLINA">LA CAROLINA</option>
                                                <option value="LA DOLOROSA DE PRIORATO">
                                                    LA DOLOROSA DE PRIORATO
                                                </option>
                                                <option value="LA ESPERANZA">LA ESPERANZA</option>
                                                <option value="LITA">LITA </option>
                                                <option value="PIMAMPIRO">PIMAMPIRO</option>
                                                <option value="SALINAS">SALINAS</option>
                                                <option value="SAN ANTONIO">SAN ANTONIO</option>
                                                <option value="SAN FRANCISCO">SAN FRANCISCO</option>
                                                <option value="URCUQUI">URCUQUI</option>
                                            </select>

                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Cantón:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_canton_bb } />
                                        </div>

                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Nombres y apellidos del propietario(s):</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_nombre_propiet_bb } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Nombres y apellidos del otorgante</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_apellidos_vendedor_bb } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Fecha aproximada de realización del contrato:</label><br />
                                            <DatePicker
                                                className="form-control form-control-user"
                                                selected={ web_fecha_aproxi_bb }
                                                onChange={ ( date ) => setweb_fecha_aproxi_bb( date ) }
                                                timeInputLabel="Hora:"
                                                dateFormat="dd/MM/yyyy"
                                            />
                                        </div>
                                        <div className="col-sm-1 mb-3 mb-sm-0">
                                            <label className="text-primary">Buscar desde(año):</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_anio_desde_bb } />
                                        </div>
                                        <div className="col-sm-1 mb-3 mb-sm-0">
                                            <label className="text-primary">Buscar hasta(año):</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_anio_hasta_bb } />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><br />
                        <div className="card border-left-primary shadow  py-2" style={ { display: activar_ct === true ? "flow-root" : "none" } }>
                            {/* Card Header - Dropdown */ }
                            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-primary">INFORMACIÓN PARA COPIA TEXTUAL - ÍNTEGRA</h6>
                            </div>
                            {/* Card Body */ }
                            <div className="card-body">
                                <div className="user">
                                    <div className="form-group row">
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Tipo de acto / contrato:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_tipo_contrato_ct } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Nro. Partida:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_npartida_ct } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Año de Inscripción:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_anioinscripcion_ct } />
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div><br />
                        <div className="card border-left-primary shadow  py-2" style={ { display: activar_bienes === true ? "flow-root" : "none" } }>
                            {/* Card Header - Dropdown */ }
                            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                <h6 className="m-0 font-weight-bold text-primary">INFORMACIÓN PARA CERTIFICADO DE BIENES</h6>
                            </div>
                            {/* Card Body */ }
                            <div className="card-body">
                                <div className="user">
                                    <div className="form-group row">
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Cédula:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_ncedula_bienes } />
                                        </div>
                                        <div className="col-sm-3 mb-3 mb-sm-0">
                                            <label className="text-primary">Apellidos y nombres:</label><br />
                                            <input type="text" className="form-control form-control-user" id="exampleFirstName" placeholder="..." ref={ web_apellidos_nombres_bienes } />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <label className="text-primary">ADJUNTAR EL CERTIFICADO DE PROPIEDADES CATASTRADAS DEL MUNICIPIO: (solo archivos pdf)</label><br />
                                            <input type="file" className="form-control form-control-user" id="exampleFirstName" placeholder="..." accept=".pdf" onChange={ onFileChange } />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div><br />
                        <div className="card border-left-primary shadow  py-2" style={ { display: activar_formulario === true ? "none" : "flow-root" } }>
                            <div className="card-body">
                                <div className="user">
                                    <div className="form-group row">
                                        <label className="text-primary">De conformidad con lo dispuesto por la ley del sistema Nacional de Registro de Datos Públicos, artículo 6 inciso quinto, expresamente señalo que formulo en mi solicitud para el siguiente objetivo:</label>
                                        <div className="col-sm-4 mb-3 mb-sm-0">
                                            <select className="form-control" ref={ web_indole_tic }>
                                                <option selected value="">Seleccione:</option>
                                                <option value="Compraventa">Compraventa</option>
                                                <option value="Judicial">Judicial</option>
                                                <option value="Hipoteca">Hipoteca</option>
                                                <option value="Municipal">Municipal</option>
                                                <option value="Privado">Privado</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><br />
                        <button className="btn btn-success" style={ { width: '100%', display: activar_formulario === true ? "none" : "flow-root" } } onClick={ async () => await setisOpenSurvey( true ) }>Generar Formulario</button>
                    </div>
                </div>
                <br />
            </section>

            <Modal show={ isOpenSurvey } backdrop="static" size="xl" centered>
                <Modal.Body>
                    <div className="card card-danger">
                        <div className="card-header">
                            <h3 className="card-title">ENCUESTA DE SATISFACCIÓN DE LA CALIDAD DEL SERVICIO VIRTUAL</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1"><strong>En una escala del 1 al 5, donde 1 es nada satisfecho y 5 es totalmente satisfecho, por favor califique su nivel de satisfacción:</strong></label>

                                <ol>
                                    <li>¿Qué tan satisfecho estás con la facilidad para encontrar este servicio en internet?</li><br />
                                    <img src={ logoencuesta } alt="Fuera de servicio" width={ "50%" } />
                                    <br />
                                    <label>Nada Satisfecho</label>
                                    &nbsp;&nbsp;&nbsp;<div className="btn-group btn-group-lg" role="group" aria-label="Basic outlined example" style={ { width: "25%" } }>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 1, 1 ) }>
                                            1
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 1, 2 ) }>
                                            2
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 1, 3 ) }>
                                            3
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 1, 4 ) }>
                                            4
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 1, 5 ) }>
                                            5
                                        </button>
                                    </div> <label>Totalmente Satisfecho</label><br />
                                    <br />
                                    <li>¿Qué tan satisfecho estás con la facilidad de navegación dentro esta página web?</li>
                                    <img src={ logoencuesta } alt="Fuera de servicio" width={ "50%" } />
                                    <br />
                                    <label>Nada Satisfecho</label>
                                    &nbsp;&nbsp;&nbsp;<div className="btn-group btn-group-lg" role="group" aria-label="Basic outlined example" style={ { width: "25%" } }>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 2, 1 ) }>
                                            1
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 2, 2 ) }>
                                            2
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 2, 3 ) }>
                                            3
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 2, 4 ) }>
                                            4
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 2, 5 ) }>
                                            5
                                        </button>
                                    </div> <label>Totalmente Satisfecho</label><br />
                                    <br />
                                    <li>¿Qué tan satisfecho estás con los pasos que realizaste para obtener este servicio?</li>
                                    <img src={ logoencuesta } alt="Fuera de servicio" width={ "50%" } />
                                    <br />
                                    <label>Nada Satisfecho</label>
                                    &nbsp;&nbsp;&nbsp;<div className="btn-group btn-group-lg" role="group" aria-label="Basic outlined example" style={ { width: "25%" } }>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 3, 1 ) }>
                                            1
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 3, 2 ) }>
                                            2
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 3, 3 ) }>
                                            3
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 3, 4 ) }>
                                            4
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 3, 5 ) }>
                                            5
                                        </button>
                                    </div> <label>Totalmente Satisfecho</label><br />
                                    <br />
                                    <li>¿Qué tan satisfecho estás con la asistencia al usuario que presta este servicio?</li>
                                    <img src={ logoencuesta } alt="Fuera de servicio" width={ "50%" } />
                                    <br />
                                    <label>Nada Satisfecho</label>
                                    &nbsp;&nbsp;&nbsp;<div className="btn-group btn-group-lg" role="group" aria-label="Basic outlined example" style={ { width: "25%" } }>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 4, 1 ) }>
                                            1
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 4, 2 ) }>
                                            2
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 4, 3 ) }>
                                            3
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 4, 4 ) }>
                                            4
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 4, 5 ) }>
                                            5
                                        </button>
                                    </div> <label>Totalmente Satisfecho</label><br />
                                    <br />
                                    <li>¿Qué tan satisfecho estás con que éste servicio se preste de manera virtual?</li>
                                    <img src={ logoencuesta } alt="Fuera de servicio" width={ "50%" } />
                                    <br />
                                    <label>Nada Satisfecho</label>
                                    &nbsp;&nbsp;&nbsp;<div className="btn-group btn-group-lg" role="group" aria-label="Basic outlined example" style={ { width: "25%" } }>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 5, 1 ) }>
                                            1
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 5, 2 ) }>
                                            2
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 5, 3 ) }>
                                            3
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 5, 4 ) }>
                                            4
                                        </button>
                                        <button type="button" className="btn btn-outline-primary" onClick={ async () => await guardarpregunta( 5, 5 ) }>
                                            5
                                        </button>
                                    </div> <label>Totalmente Satisfecho</label><br />
                                    <br /><br />
                                </ol>
                            </div>
                            <button
                                className="btn btn-danger"
                                onClick={ finaliza_encuesta }
                                disabled={ habilitarcerrar === false ? true : false }
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={ isOpenObs } centered>
                <Modal.Body>
                    <div className="card card-danger">
                        <div className="card-header">
                            <h3 className="card-title">Datos adicionales</h3>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1">*Si necesita realizar algún requerimiento adicional en el presente trámite por favor ingréselo a continuación:</label>
                                <textarea
                                    class="form-control"
                                    ref={ datos_adicionales }
                                    placeholder="Ingrese datos adicionales aquí..."
                                    rows={ 10 }

                                ></textarea>

                            </div>
                            &nbsp;
                            <button
                                className="btn btn-success"
                                onClick={ onFileUpload }
                            >
                                Generar Formulario
                            </button>&nbsp;
                            <button
                                className="btn btn-danger"
                                onClick={ () => setisOpenObs( false ) }
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default Gravámenes;
